import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Fingerprint, ShieldCheck } from 'lucide-react';
import './Passkey.css';

const PasskeySetupModal = ({
    show,
    onSkip,
    onSetup,
    busy = false,
    error = '',
    supported = true,
    supportMessage = '',
    title = 'Create a passkey?',
    description = 'Use your fingerprint, face, or screen lock to sign in next time — no password needed.',
    confirmText = 'Create passkey',
    cancelText = 'Not now',
    cancelDisabled,
}) => {
    return (
        <Modal
            show={show}
            onHide={busy ? undefined : onSkip}
            centered
            backdrop="static"
            keyboard={!busy}
            dialogClassName="passkey-setup-modal"
            className="passkey-setup-modal"
        >
            <Modal.Body className="passkey-setup-modal__body">
                <div className="passkey-setup-hero">
                    <span className="passkey-setup-hero__icon" aria-hidden="true">
                        <Fingerprint size={28} strokeWidth={1.75} />
                    </span>
                    <h4>{title}</h4>
                    <p>{description}</p>

                    {/* <ul className="passkey-setup-hero__perks">
                        <li>
                            <ShieldCheck size={16} aria-hidden="true" />
                            <span>Faster sign-in on this device</span>
                        </li>
                        <li>
                            <ShieldCheck size={16} aria-hidden="true" />
                            <span>More phishing-resistant than passwords</span>
                        </li>
                    </ul> */}

                    {!supported && supportMessage ? (
                        <div className="passkey-alert passkey-alert--info">{supportMessage}</div>
                    ) : null}
                    {error ? <div className="passkey-alert passkey-alert--error">{error}</div> : null}
                </div>
            </Modal.Body>
            <Modal.Footer className="passkey-setup-modal__footer border-0">
                <Button
                    type="button"
                    variant="outline-secondary"
                    disabled={cancelDisabled ?? busy}
                    onClick={onSkip}
                >
                    {cancelText}
                </Button>
                <Button
                    type="button"
                    className="btn btn-primary"
                    disabled={busy || !supported}
                    onClick={onSetup}
                >
                    {busy ? 'Waiting…' : confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PasskeySetupModal;
